<template>
	<v-row
		v-bind="$attrs"
		v-on="$listeners"
		:align="align"
	>
		<slot />
	</v-row>
</template>

<script>
export default {
	name: 'KRow',
	inheritAttrs: false,
	props: {
		align: {
			type: String,
			default: undefined,
		},
	},
}
</script>